import styled, {createGlobalStyle} from 'styled-components';
import {getSpacing} from '@tickchak/react-share/app';
import {AI_BRAND_GRADIENT_BORDER_WIDTH, AI_BRAND_GRADIENT_HORIZONTAL, AI_BRAND_GRADIENT_VERTICAL} from './aiGeneratorButton/AIGeneratorButton.css';
import {alignEnd, dFlexColumn, dFlexColumnAlineEnd, justifyBetween} from '../../globalVariables/GlobalFlex';
import {mobileMedia, scrollbar} from '../../globalVariables/GlobalVariables';

export const panelGradientStyles = createGlobalStyle`
    .ai-message-generator-panel {
        border-color: transparent;
        border-inline-start-width: ${AI_BRAND_GRADIENT_BORDER_WIDTH};
        background-image:
            linear-gradient(var(--color-bg-base), var(--color-bg-base)),
            ${AI_BRAND_GRADIENT_VERTICAL};
        background-clip: padding-box, border-box;

        ${mobileMedia} {
            border-inline-start-width: 0;
            border-block-start-width: ${AI_BRAND_GRADIENT_BORDER_WIDTH};
            background-image:
                linear-gradient(var(--color-bg-base), var(--color-bg-base)),
                ${AI_BRAND_GRADIENT_HORIZONTAL};
        }
    }
    .ai-message-generator-header {
        border: none;
    }
`;

export const panelInner = styled.div`
    height: calc(100% - 80px);
    padding: ${getSpacing('spaceXl')};
    ${dFlexColumn};
    ${justifyBetween};
`;

export const scrollArea = styled.div`
    position: relative;
    flex: 1;
    min-height: 0;
    ${dFlexColumn};
`;

export const scrollColumn = styled.div`
    ${dFlexColumn};
    ${scrollbar};
    flex: 1;
    min-height: 0;
`;

export const chatColumn = styled.div`
    ${dFlexColumn}
    ${alignEnd}
    gap: ${getSpacing('spaceLg')};
    width: 100%;
`;

export const promptArea = styled.div`
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-2xl);
    padding: ${getSpacing('spaceSm')};
    box-shadow: 0 2px 6px -3px rgba(0, 0, 0, 0.28);
    ${dFlexColumnAlineEnd}
    gap: ${getSpacing('spaceLg')};
    height: max-content;
    flex-shrink: 0;
    margin-top: ${getSpacing('spaceSm')};
`;

export const PROMPT_TEXTAREA_MAX_HEIGHT_PX = 200;

export const promptTextarea = styled.textarea`
    width: 100%;
    border: none;
    resize: none;
    overflow: hidden;
    box-sizing: border-box;
    min-height: 20px;
    max-height: ${PROMPT_TEXTAREA_MAX_HEIGHT_PX}px;
    padding: ${getSpacing('spaceSm')} ${getSpacing('spaceLg')};
    font-size: var(--font-size-body-small, 14px);
    font-family: inherit;
    line-height: 1.2;
    color: var(--ta-color-text-default, #000);
    background: transparent;

    &::placeholder {
        color: var(--ta-color-text-subtle, rgba(0, 0, 0, 0.4));
    }

    &:focus {
        outline: none;
    }
    ${mobileMedia} {
        font-size: 16px;
    }
`;

export const errorText = styled.p`
    margin: ${getSpacing('spaceSm')} 0 0;
    font-size: var(--font-size-body-small, 14px);
    color: var(--color-state-danger-text);
`;
